import Grid from '../../../elements/Grid'
import Card from '../../../elements/Card'
import Button from '../../../elements/Button'
import Container from '../../../elements/Container'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import SlickSlider from '../../../elements/SlickSlider'
import Section from '../../../elements/Section'
import isEmpty from 'lodash-es/isEmpty'
import EstateCard from '../../../custom/EstateCard'

const Rentals = ({
  title,
  properties = false,
  intro = false,
  buttonLabel,
  buttonLink = '/vacation-rentals',
  target = 'listings',
  background = 'primary',
  bottomTitle = 'Your direct line to exclusive<br /> villa rentals in St. Martin / St. Maarten',
  bottomDescription = "Thanks to our locally-based reservations team, you get access to the best properties that fit your exact needs. But it doesn't end there. When you arrive, we'll be here to greet you and ensure your experience lives up to expectations.",
  cardTranslation
}) => {
  const { isMobile, isSmallMobile } = useResponsive()

  if (isEmpty(properties) || !properties) {
    return
  }

  return (
    <Section variant={['center', background, 'o-hidden']}>
      <Container variant={isMobile && ['-p0']}>
        <h2
          dangerouslySetInnerHTML={{
            __html: title
          }}
          className={styles.title}
        ></h2>

        {isSmallMobile ? (
          <div className={styles.content}>
            {properties &&
              properties.length &&
              properties.map((item, index) =>
                target === 'listings' ? (
                  <Card translations={cardTranslation} key={index} {...item} />
                ) : (
                  <EstateCard
                    translations={cardTranslation}
                    key={`estate-card-${index}`}
                    {...item}
                  />
                )
              )}
          </div>
        ) : isMobile ? (
          <SlickSlider
            arrows={false}
            className={styles.properties}
            pagination={intro}
            slidesToShow={1}
            infinite={false}
            variableWidth
          >
            {properties &&
              properties.length &&
              properties.map((item, index) =>
                target === 'listings' ? (
                  <Card
                    sizes="(min-width: 1250px) 588px, (max-width: 1250px) 50vw,
            50vw"
                    translations={cardTranslation}
                    key={index}
                    {...item}
                  />
                ) : (
                  <EstateCard
                    translations={cardTranslation}
                    key={`estate-card-${index}`}
                    {...item}
                  />
                )
              )}
          </SlickSlider>
        ) : (
          <Grid variant={['grid-2']}>
            {properties &&
              properties.length &&
              properties.map((item, index) =>
                target === 'listings' ? (
                  <Card
                    translations={cardTranslation}
                    sizes="(min-width: 1250px) 588px, (max-width: 1250px) 50vw,
            50vw"
                    key={index}
                    {...item}
                  />
                ) : (
                  <EstateCard
                    translations={cardTranslation}
                    key={`estate-card-${index}`}
                    {...item}
                  />
                )
              )}
          </Grid>
        )}
      </Container>

      <Container variant={['-xs2']}>
        {intro && (
          <>
            <div className={styles.divider}></div>

            <h3
              dangerouslySetInnerHTML={{
                __html: bottomTitle
              }}
            ></h3>

            <p
              dangerouslySetInnerHTML={{
                __html: bottomDescription
              }}
              className={styles.description}
            ></p>
          </>
        )}

        <Button
          href={buttonLink}
          variant={[
            !intro && 'mt-lg',
            'xl',
            background !== 'primary' ? 'color-primary' : ''
          ]}
        >
          {buttonLabel}
        </Button>
      </Container>
    </Section>
  )
}

export default Rentals
